"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  root: {
    opacity: 1,
    padding: '20px',
    borderRadius: '5px',
    display: 'flex',
    transition: 'opacity 0.3s, height 0.3s',
    boxSizing: 'border-box',
    background: function (_ref) {
      var type = _ref.type;
      if (type === 'success') return '#E0F4F0';
      if (type === 'warning') return '#FEEBE0';
      if (type === 'error') return '#FFD2D2';
      return '#FFFFFF';
    },
    boxShadow: function (_ref2) {
      var hasShadow = _ref2.hasShadow;
      return hasShadow ? '0 2px 4px 0 #E9E9EA' : '';
    }
  },
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0
  },
  contentWrapper: {
    flex: '1 1 auto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px'
  },
  closeIconWrapper: {
    flex: '0 0 auto',
    cursor: 'pointer'
  }
};
var _default = styles;
exports["default"] = _default;